import { i18n } from 'next-i18next';

const setLocale = (languagePref: string): void => {
    document.documentElement.lang = languagePref;
    if (i18n) {
        i18n.language = languagePref;
        i18n.changeLanguage(i18n.language);
    }
    localStorage.setItem('cxp-i18n', languagePref);
};

export default setLocale;
